import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { differenceInMilliseconds } from "date-fns";
import { useScheduleContext } from "./ScheduleContext";

type ScheduleHeadersProps = {
  firstColumnHeader: React.ReactNode;
};

const ColumnLabel = styled("div")({
  position: "absolute",
  insetBlock: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontWeight: "bold",
  padding: 8,
});

const ScheduleHeaders = ({ firstColumnHeader }: ScheduleHeadersProps) => {
  const {
    entries,
    columns,
    fromDate,
    totalDuration,
    enableSelection,
    selectedEntries,
    setSelectedEntries,
  } = useScheduleContext();

  return (
    <TableHead>
      <TableRow>
        {enableSelection && (
          <TableCell padding="checkbox">
            <Checkbox
              disabled={entries.length === 0}
              indeterminate={selectedEntries.length > 0 && selectedEntries.length < entries.length}
              checked={selectedEntries.length === entries.length && entries.length > 0}
              onChange={() => {
                if (selectedEntries.length > 0) {
                  setSelectedEntries([]);
                } else {
                  setSelectedEntries(entries.map((entry) => entry.id));
                }
              }}
            />
          </TableCell>
        )}
        <TableCell>{firstColumnHeader}</TableCell>

        <TableCell
          colSpan={columns.length}
          width="100%"
          sx={{ position: "relative", overflow: "hidden" }}
        >
          {columns.map((column) => (
            <ColumnLabel
              key={column.startDate.toISOString()}
              style={{
                left: `${(differenceInMilliseconds(column.startDate, fromDate) / totalDuration) * 100}%`,
                width: `${column.ratio}%`,
              }}
            >
              {column.name}
            </ColumnLabel>
          ))}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default ScheduleHeaders;
